export default {
	id: "phantouch-carpenter-shack",
	pride: 8192,
	slug: "phantouch-carpenter-shack",
	category: "vrchat",
	status: "released",
	experienceable: true,
	titleKey: {
		zh: "木匠的奇妙工具小屋"
	},
	descriptionKey: {
		zh: "木匠主题的幻触工具房间。留声机是无目的创作的例子之一。"
	},
	date: { year: 2026, month: 6 },
	genres: ["VRChat", "工具", "社交"],
	themes: ["木匠", "幻触"],
	engine: "Unity (VRChat)",
	platform: ["PCVR", "Quest"],
	tags: ["VRChat", "幻触"],
	links: [
		{ type: "vrchat", url: "https://vrchat.com/home/world/wrld_b82ea8c8-ee7a-4e72-9986-5b5dbe69c940", textKey: { zh: "VRChat 访问" } }
	]
};
